














































































import Vue from 'vue';

export default Vue.extend({
  props: {
    unidad: {
      type: Object,
      default: null,
    },
    propietario: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    openDialog: false,
    loading: false,
    unidades: [],
    unidadSeleccionada: {},
    propietarios: [],
    propietarioSeleccionado: {},
    datePicker: false,
    fecha: '',
  }),
  methods: {
    async loadData() {
      this.fecha = this.$moment().format();
      try {
        this.loading = true;
        const admin = this.$store.getters.getAdmin;
        const condo = this.$store.getters.getCondo;
        const datos = {admin, condo};
        console.debug('getUnidadesListMax datos: %o', datos);
        const response = await this.$store.dispatch('getUnidadesListMax', {datos});
        console.debug('getUnidadesListMax response: %o', response);
        this.unidades = response.content;
        this.assignUnidad();
      } catch (e) {
        console.error(e);
        this.$toast.error(e);
      }
      try {
        this.loading = true;
        const admin = this.$store.getters.getAdmin;
        const condo = this.$store.getters.getCondo;
        const datos = {admin, condo};
        console.debug('getPropietCondoListMax datos: %o', datos);
        const response = await this.$store.dispatch('getPropietCondoListMax', datos);
        console.debug('getPropietCondoListMax response: %o', response);
        this.propietarios = response.content;
        this.assignPropietario();
      } catch (e) {
        console.error(e);
        this.$toast.error(e);
      }
      this.loading = false;
    },
    assignUnidad() {
      let uni = {};
      if (this.unidad !== null) {
        uni = this.unidades.find((el) => el.id === this.unidad.id);
      }
      if (uni === undefined) {
        this.unidadSeleccionada = {};
      } else {
        this.unidadSeleccionada = uni;
      }
    },
    assignPropietario() {
      let prop = {};
      if (this.propietario !== null) {
        prop = this.propietarios.find((el) => el.id === this.propietario.id);
      }
      if (prop === undefined) {
        this.propietarioSeleccionado = {};
      } else {
        this.propietarioSeleccionado = prop;
      }
    },
    async AsociarUnidadPropietario() {
      try {
        const admin = this.$store.getters.getAdmin;
        const condo = this.$store.getters.getCondo;
        const periodo = this.formattedDate;
        const relacion = {
          condominio: condo,
          condomino: this.propietarioSeleccionado,
          unidades: this.unidadSeleccionada,
          propietarioInquilino: this.propietarioSeleccionado.isPropietary,
        };
        const propUnidad = {
          periodo,
          relacion,
        };
        const datos = {admin, condo, propUnidad};
        console.log('asociarPropietCondo datos: ', datos);
        const response = await this.$store.dispatch('asociarPropietCondo', datos);
        console.log('asociarPropietCondo response: ', response);
        this.$toast.success('Unidad y propietario asociados exitosamente');
      } catch (e) {
        console.error(e.response);
        this.$toast.error(e.response.data.message);
      }
      return;
    },
    closeDialog() {
      this.openDialog = false;
    },
  },
  watch: {
    openDialog() {
      if (this.openDialog) {
        this.loadData();
      }
    },
  },
  computed: {
    formattedDate() {
      return this.$moment(this.fecha).format('YYYY-MM-DD');
    },
  },
});
